import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import logDataOnSaveEvents from '../utils/logDataOnSaveEvents';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import { getMeetingDuration } from '../selectors/getMeetingDuration';
import { getReminderTime } from '../selectors/getReminderTime';
import { updateUserOptions } from 'owa-options-core';
import {
    saveCalendarMailboxConfiguration,
    updateCalendarMailboxConfiguration,
} from 'owa-calendar-configuration';
import { action } from 'satcheljs/lib/legacy';

/*
    Called when clicked on save button in calendar settings panel.
    Updates user options so that the changes are reflected in current user session
    Updates the calendar configuration on local store and on server
*/

export default action('saveEventOption')(async function saveEventOption() {
    let defaultReminderTime = getReminderTime();
    let defaultMeetingDuration = getMeetingDuration();

    const partialCalendarMailboxConfiguration = {
        DefaultReminderTime: defaultReminderTime,
        DefaultMeetingDuration: defaultMeetingDuration,
    };

    // update the UserOptions so that changes reflect in current session
    updateUserOptions(partialCalendarMailboxConfiguration);

    updateCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);

    // save the new calendar configuration at server
    const response: OptionsResponseBase = await saveCalendarMailboxConfiguration(
        partialCalendarMailboxConfiguration
    );

    if (response.WasSuccessful) {
        // Same as JsMVVM, we need to copy the mailboxCalendarConfiguration.DefaultReminderTime to UserOptions.DefaultReminderTimeInMinutes, because
        // the latter field is used in Compose meeting form to show default reminder time. Without copying this field, the default reminder
        // time in compose form is the old value until the session refreshes.
        getUserConfiguration().UserOptions.DefaultReminderTimeInMinutes = defaultReminderTime;
    }

    logDataOnSaveEvents();
});
